<template>
  <slot v-bind="props.set" />
</template>

<script lang="ts" setup generic="const T extends Record<any, any>">
const props = defineProps<{ set: T }>()
</script>